export default __webpack_public_path__ + "static/media/new1.95fe4aa9.png";